import { React, ts } from '_core';

import Chart from './chart';
import { DraftParams, Params } from './types';

type RiskModelConditionNumberProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  params: Params;
  setParams: (_p: DraftParams) => void;
  title: string;

  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  widgetPaths?: Record<'risk_model_condition_number', string>;
  goFullScreen: (_q: string) => void;
  fullScreen: boolean;
};

const RiskModelIndustryCoverage = ({
  id,
  readOnly,
  title,
  loadWidgetData,
  widgetPaths,
  fullScreen,
}: RiskModelConditionNumberProps) => {
  return (
    <Chart
      file={widgetPaths['risk_model_condition_number']}
      loadWidgetData={loadWidgetData}
      fullScreen={fullScreen}
      id={id}
      readOnly={readOnly}
      title={title}
    />
  );
};

export default RiskModelIndustryCoverage;
